//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'
import 'devextreme/ui/tabs'
import 'devextreme/ui/text_box'
import 'devextreme/ui/toolbar'

//#endregion

import { Api } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { GridSelectController } from './grid-select.controller'
import { ColumnInfo } from '../../../models/custom/column-info';
import { IOpObject } from '../../../models/util/interfaces';
import { ColumnModel } from '../../api/api.models';
import { IUserSession } from '../../../helpers/user-session'
import { GridDataSourceParserDelegate } from '../grid';

//#region Asset Imports

import './grid-select.scss'
import * as TEMPLATE from './grid-select.tpl.html'

//#endregion

export interface GridSelectBridge {
    value: any
    elements: any[]
    data?: any[]
    dataRequest(request): ng.IPromise<any>
    columnRequest(): ng.IPromise<any>
    onSelect(e): void
    onSelected?: (e) => any
    onDoubleRowClick(e): void
    name: string
    onAddClick?: (grid: DevExpress.ui.dxDataGrid) => void
    addPermissions?: string
    localStorageVarForSavedEntity?: string
    selection?: any

    gridItemFilter?: (item: any) => boolean
    getAvailableDataSourceMethod?: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => JQueryPromise<{ objects: IOpObject[], totalCount: number, error: { code: any, msg: string } }>
    dataSourceParser?: GridDataSourceParserDelegate

    columnsDictionary?: ColumnModel[],
    allowColumnReordering?: boolean

    gridReferenceId?: number
}

export class GridSelectDirective implements ng.IDirective {

    scope = {
        'bridge': '=bridge',
        popupVisible: '=?',
        addButtonClicked: '=?'
    }
    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', '$compile', 'localDictionary', 'userSession', (
        $scope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        $compile: ng.ICompileService,
        localDictionary,
        userSession: IUserSession
    ) => {
        return new GridSelectController($scope, $q, $timeout, api, logger, $compile, localDictionary, userSession)
    }]

    template = TEMPLATE
    replace = true
}